// 管理员管理
import http from "@/jslibs/axios/http";

// 新增管理员
export const add = (data) => http.post("/cms/admin/add", data);

// 编辑管理员
export const edit = (data) => http.post("/cms/admin/update", data);

// 管理员详情
export const detail = (id) => http.get("/cms/admin/details/" + id);

// 管理员分页列表
export const page = (data) => http.get("/cms/admin/page", data);

// 管理员删除
export const del = (id) => http.delete("/cms/admin/" + id);
